const codeBtns = document.querySelectorAll(".s-form-init__code-open")
codeBtns.forEach(btn => {
  btn.addEventListener("click", () => {
    const codeInput = btn.nextElementSibling
    codeInput.classList.remove("--hidden")
  })
});
